export default __webpack_public_path__ + "static/blog3-498d31b7edab5e2ba8d0e753ed7309d8.webp";